import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fa466808"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "toolbox relative inline-block z-60" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    class: "fas fa-question h-6 w-6 text-gray-500",
    "aria-hidden": "true"
}, null, -1));
const _hoisted_3 = { class: "hidden inline-block absolute transition-opacity duration-500 invisible z-10 py-2 px-3 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700 w-80 ml-2 tablet:inset-x-0 tablet:top-4 tablet:ml-0" };
const _hoisted_4 = { class: "text-primary text-center bg-white uppercase rounded p-1 mb-1" };
const _hoisted_5 = { class: "text-white" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "source", {}, () => [
            _hoisted_2
        ], true),
        _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.text, (textItem) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: "flex flex-col whitespace-pre-line my-2",
                    key: textItem
                }, [
                    _createElementVNode("h5", _hoisted_4, _toDisplayString(textItem.title), 1),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(textItem.explanation), 1)
                ]));
            }), 128))
        ])
    ]));
}
